import React from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ListItem, ListItemIcon, ListItemText, Divider, Box } from '@mui/material';
import {
  CreateOutlined,
  Event, HomeOutlined, PersonOutlineOutlined,
  ShoppingCartOutlined,
  CloseOutlined
} from '@mui/icons-material';
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const GeneralMenu = ({ isAuthenticated, unreadCount, closeMenus, loginWithRedirect, logoutWithRedirect, isMobile }) => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => {
    return currentPath.includes(path);
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      gap: "50px",
      width: '100%'
    }}>
      <Box sx={{ marginTop: '20px' }}>
        <ListItem button component={Link} onClick={() => { if (isMobile) closeMenus(); }} to="/" sx={{ color: "#4B4D63", textDecoration: "none" }} className="drawer-item">
          <ListItemIcon sx={{ minWidth: "40px" }}><HomeOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText primary={t("navbar.home")}
            primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/`) ? 600 : 400 }
            }} />
        </ListItem>

        <ListItem button component={Link} to="/creaeventos" onClick={() => { if (isMobile) closeMenus(); }} sx={{ color: "#4b4d63", textDecoration: "none" }} className="drawer-item">
          <ListItemIcon sx={{ minWidth: "40px" }}><CreateOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText primary={t("navbar.createEvents")} primaryTypographyProps={{
            fontFamily: "Bricolage Grotesque",
            sx: { fontSize: "14px", color: "#4B4D63", fontWeight: currentPath === `/creaeventos` ? 600 : 400 }
          }} />
        </ListItem>

        {isAuthenticated && (
          <>
            <ListItem button component={Link} to="/eventos" onClick={() => { if (isMobile) closeMenus(); }} sx={{ color: "#4B4D63", textDecoration: "none" }} className="drawer-item">
              <ListItemIcon sx={{ minWidth: "40px" }}><Event style={{ color: "#4B4D63" }} /></ListItemIcon>
              <ListItemText primary={t("navbar.myEvents")} primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/eventos`) ? 600 : 400 }
              }} />
            </ListItem>

            <ListItem button component={Link} to="/mis-compras" onClick={() => { if (isMobile) closeMenus(); }} sx={{ color: "#4b4d63", textDecoration: "none" }} className="drawer-item">
              <ListItemIcon sx={{ minWidth: "40px" }}><ShoppingCartOutlined style={{ color: "#4b4d63" }} /></ListItemIcon>
              <ListItemText primary="Mis compras" primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/mis-compras`) ? 600 : 400 }
              }} />
            </ListItem>

            <ListItem button component={Link} to="/profile" onClick={() => { if (isMobile) closeMenus(); }} sx={{ color: "#4b4d63", textDecoration: "none" }} className="drawer-item">
              <ListItemIcon sx={{ minWidth: "40px" }}><PersonOutlineOutlined style={{ color: "#4b4d63" }} /></ListItemIcon>
              <ListItemText primary={t("navbar.profile")} primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/profile`) ? 600 : 400 }
              }} />
            </ListItem>
          </>
        )}
      </Box>

      <Box sx={{ marginTop: 'auto' }}>
        <Divider style={{ backgroundColor: '#4b4d63', width: '100%', margin: '10px 0' }} />

        <ListItem
          button
          onClick={() => {
            if (isMobile) {
              if (typeof window !== "undefined") {
                window.localStorage.setItem("drawerClosedManually", "true");
              }
            }
            closeMenus();
          }}
          sx={{
            color: "#4B4D63",
            textDecoration: "none",
            justifyContent: "center",
            marginTop: "10px",
            cursor: "pointer",
          }}
          className="drawer-item"
        >
          <ListItemIcon sx={{ minWidth: "40px" }}>
            <CloseOutlined style={{ color: "#4b4d63" }} />
          </ListItemIcon>
          <ListItemText primary="Ocultar menú" primaryTypographyProps={{
            fontFamily: "Bricolage Grotesque",
            sx: { fontSize: "14px", color: "#4B4D63" }
          }} />
        </ListItem>
      </Box>
    </Box>
  );
};

export default GeneralMenu;